export const ENROLLMENTS_3_CONSTANTS = {
  ENROLLMENTS_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title (wrap highlight in { } e.g. Why pursue {this programme})",
      value: "Why Pursue {this Programme}",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Why Pursue {this Programme}",
      required: false,
      defaultValue: "Why Pursue {this Programme}",
      rows: 2,
    },
    {
      fieldName: "description",
      label: "Description",
      value: "Take the next step in your career",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Take the next step in your career",
      required: false,
      defaultValue: "Take the next step in your career",
      rows: 3,
    },
    {
      fieldName: "cta_label",
      label: "Button label",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Apply Now",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "cta_url",
      label: "Button URL",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/path or https:// — used when 'Open lead popup' is off",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "open_in_new_tab",
      label: "Open link in new tab",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "enable_lead_popup",
      label: "Is CTA — open lead popup",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "On = lead capture popup instead of button URL",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "desktop_image",
      label: "Desktop background image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload desktop background image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_image",
      label: "Mobile background image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload mobile background image (falls back to desktop)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "background_color",
      label: "Section background color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "overlay_color",
      label: "Overlay color (on top of image)",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "overlay_opacity",
      label: "Overlay opacity (0–1, e.g. 0.5)",
      value: "0.5",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "0.5",
      required: false,
      defaultValue: "0.5",
    },
    {
      fieldName: "title_color",
      label: "Title color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_highlight_color",
      label: "Title highlight color (for {...} text)",
      value: "#FFD700",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFD700",
      required: false,
      defaultValue: "#FFD700",
    },
    {
      fieldName: "description_color",
      label: "Description color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_background_color",
      label: "Button background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_text_color",
      label: "Button text color",
      value: "#DB5803",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#DB5803",
      required: false,
      defaultValue: "#DB5803",
    },
    {
      fieldName: "status",
      label: "Section Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Section",
      defaultValue: true,
    },
  ],
};
